// @flow

import clsx from 'clsx';

import { useTranslator } from '@gandi/translate';
import { Card } from '@gandi/ui/deprecated';

import { useFeatureFlag } from 'src/hooks/useFeatureFlag';

import { CallToActionFooter } from './CallToActionFooter';
import { ProductTile } from './ProductTile';

import type { Type } from './ProductTile';

import styles from './CallToAction.scss';

const noMarginBottom = { marginBottom: 0 };
const noMargin = { margin: 0 };

const productTypes: Array<Type> = [
  'domain',
  'certificate',
  'paas',
  'cloud',
  'mailbox-standalone',
];

export function CallToAction({
  isEmptyPage,
}: {
  isEmptyPage?: boolean,
}): React.MixedElement {
  const { __ } = useTranslator();
  const FF_SHOP_CONFIRMATION_NDS = useFeatureFlag('FF_SHOP_CONFIRMATION_NDS');

  if (isEmptyPage || FF_SHOP_CONFIRMATION_NDS) {
    return (
      <section
        className={clsx(
          styles.root,
          isEmptyPage ? styles.emptyPage : undefined,
        )}
      >
        <h3 style={noMargin}>{__('Continue shopping')}</h3>
        <div className={styles.products}>
          {productTypes.map(productType => (
            <ProductTile key={productType} type={productType} />
          ))}
        </div>
      </section>
    );
  }

  return (
    <Card className={styles.root} footer={<CallToActionFooter />}>
      <h3 style={noMarginBottom}>{__('Continue shopping')}</h3>
    </Card>
  );
}
